/**
 * Cookie
 * @class
 */
var cookie = {
  /**
   * 获取Cookie值
   * @name F.tool.cookie.get
   * @method
   * @grammar F.tool.cookie.get(name)
   * @param {String} name Cookie名
   * @shortcut F.cookie.get
   * @see F.tool.cookie.set,F.tool.cookie.del,F.cookie.set,F.cookie.del
   * @remark
   *
   返回对应值前, 会对字符串进行解码

   * @return {String} Cookie值
   */
  get: function (name) {
    // eg: 'name1=value1; name2=value2; name3=value3; name4=value4'
    var c = document.cookie;
    if (!c.length) {
      return '';
    }
    var tp = c.split('; ');
    for (var i = tp.length - 1; i >= 0; i--) {
      var tm = tp[i].split('=');
      if (tm.length > 1 && tm[0] == name && tm[1]) {
        return unescape($.trim(tm[1]));
      }
    }
    return '';
  },
  /**
   * 设置Cookie值
   * @name F.tool.cookie.set
   * @function
   * @grammar F.tool.cookie.set(name, value[, day, domain])
   * @param {String} name Cookie名
   * @param {String} value Cookie值
   * @param {String} day 有效天数, 默认 365天，-1则设置为会话cookie
   * @param {String} domain Cookie保存的域, 默认为 .funshion.com
   * @param {String} usehost 使用host设置cokie
   * @shortcut F.cookie.set
   * @see F.tool.cookie.get,F.tool.cookie.del,F.cookie.get,F.cookie.del
   * @remark
   *
   会对Cookie值进行字符串编码后存储

   */
  set: function (name, value, day, domain, usehost) {
    day = day || 365, domain = domain || '.baofeng.com', usehost = usehost || 0;
    if (/localhost/.exec(location.host)) {
      domain = location.host;
      usehost = 1;
    }
    var expires = new Date();
    expires.setTime((new Date()).getTime() + 3600 * 24 * 1000 * day);
    document.cookie = name + '=' + escape(value) + '; path=/; ' + (usehost ? 'host' : 'domain') + '=' + domain + (day == -1 ? '' : ';expires=' + expires.toGMTString());
    // document.cookie = name + '=' + escape( value ) + '; path=/;expires=' + expires.toGMTString();
  },
  /**
   * 获取Cookie值
   * @name F.tool.cookie.del
   * @function
   * @grammar F.tool.cookie.del(name)
   * @param {String} name Cookie名
   * @shortcut F.cookie.del
   * @see F.tool.cookie.get,F.tool.cookie.set,F.cookie.get,F.cookie.set
   */
  remove: function (name) {
    this.set(name, '', -365, null, 0);
    this.set(name, '', -365, document.location.host, 1);
  },
  /*
  清理暴风冗余cookie
   */
  format: function (obj) {
    try {
      delete obj.userbaseinfo['bind_third_list']
      delete obj.userbaseinfo['mail']
      delete obj.userbaseinfo['open_id']
      delete obj.userbaseinfo['real_name']
      delete obj.userbaseinfo['code']
      delete obj.userbaseinfo['msg']
      delete obj.userbaseinfo['platform_code']
      delete obj.userbaseinfo['platform_id']
      delete obj.userbaseinfo['platform_name']
      delete obj.userbaseinfo.user_icon['big']
      delete obj.userbaseinfo.user_icon['middle']
      delete obj.userbaseinfo.user_icon['small']
      delete obj.uservipinfo['coupon_num']
      delete obj.uservipinfo['items']
    } catch (error) {
      return obj
    }
    return obj
  }
};
window.cookie = cookie;
export default cookie;
export {
  cookie
}



// WEBPACK FOOTER //
// ./src/assets/js/cookie.js